import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { comnUtils } from "@/comn/utils";
import { Button, Grid, Group, Layout, Page } from "@/comn/components";
import { useFetch, useForm, useGrid, useStore, useTheme, useResource, usePage, useToast } from "@/comn/hooks";
import { APIS, URLS, SF_SCTN_SRCH, SG_SCTN_LIST } from "@/tra/tancis/ptli/usr/sctn/services/PtliSctnService";

/*
 * Section Management List
 * !== 섹션 관리 목록 ==!
 */
export const PTLI0918001Q = (): JSX.Element => {
    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0015", "auth_ptlianyADM"],
    });
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const { theme } = useTheme();
    const { pgeStore, setStore, getStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast();

    useResource({
        defaultSchema: [{ area: "comnCd", comnCd: "PTL0021" }, { area: "cstmOrgzCd" }],
    });

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        sctnSrch: useForm({
            defaultSchema: SF_SCTN_SRCH,
            defaultValues: { ...pgeStore?.form, langCd: theme.lang.toUpperCase() || "" },
        }),
    };

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        sctnList: useGrid({
            defaultSchema: SG_SCTN_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        getSctnList: useFetch({
            api: (page = grid.sctnList.page) => {
                return APIS.getSctnList(form.sctnSrch.getValues(), page, grid.sctnList.size);
            },
            enabled: comnUtils.isEmpty(form.sctnSrch.errors) && form.sctnSrch.isSubmitted,
            key: [grid.sctnList.page, grid.sctnList.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.sctnSrch.getValues(),
                    page: grid.sctnList.page,
                    size: grid.sctnList.size,
                });
            },
        }),
    };
    const render = {
        cell: {
            cstmOrgzCd: (props: any) => {
                const { rowValues, value } = props;
                return <Link to={`${URLS.ptli0918003q}/${rowValues.cstmOrgzCd}`}>{value}</Link>;
            },
        },
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        // Click Search Button !== 검색버튼 ==!
        onSrchBtnClick: () => {
            form.sctnSrch.handleSubmit(
                (data) => {
                    grid.sctnList.setPage(0);
                    fetch.getSctnList.fetch(0);
                },
                (data) => {
                    toast.showToast({ type: "warning", content: "msg.00002" });
                },
            )();
        },
    };

    /*
     * Declaration Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {
        handler.onSrchBtnClick();
    }, [theme.lang]);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.sctnSrch.schema.cstmOrgzCd} />
                            <Group.Control {...form.sctnSrch.schema.cstmOrgzTpCd} />
                        </Group.Row>
                    </Group.Section>
                    <Layout>
                        <Layout.Left>
                            <Button role={"reset"} onClick={() => form.sctnSrch.reset()} />
                        </Layout.Left>
                        <Layout.Right>
                            <Button
                                role={"search"}
                                onClick={() => {
                                    handler.onSrchBtnClick();
                                }}
                            />
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Grid {...grid.sctnList.grid} data={fetch.getSctnList.data?.sctnList} render={render} />
                    </Group.Section>
                </Group.Body>
            </Group>
            <Layout direction="row">
                <Layout.Button
                    role="new"
                    onClick={() => {
                        navigate(`${URLS.ptli0918002s}?menuId=${menuId}`);
                    }}
                ></Layout.Button>
            </Layout>
        </Page>
    );
};
